(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-size-chart"] && !Shopify.designMode) return;
  try {
    
  class AdvancedSizeChart {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('[data-size-chart-dialog]');
      this.tabs = Array.from(root.querySelectorAll('[data-size-chart-tab]'));
      this.panels = Array.from(root.querySelectorAll('[data-size-chart-panel]'));
      this.unitButtons = Array.from(root.querySelectorAll('[data-size-chart-unit-button]'));
      this.mountToAmazonProductSizeRow();
      this.bindDialog();
      this.bindTabs();
      this.bindUnits();
      this.bindFitTools();
    }

    transition(callback) {
      if (document.startViewTransition) {
        document.startViewTransition(callback);
        return;
      }

      callback();
    }

    mountToAmazonProductSizeRow() {
      if (!this.root.classList.contains('advanced-size-chart--modal')) {
        return;
      }

      const sizeHeading = document.querySelector('.amazon-product .ap-size-group .ap-option-heading');

      if (!sizeHeading || sizeHeading.contains(this.root)) {
        return;
      }

      const sectionWrapper = this.root.closest('.section-advanced-size-chart');
      const inlineSizeChart = sizeHeading.querySelector('.ap-size-chart-inline');

      if (inlineSizeChart) {
        inlineSizeChart.hidden = true;
      }

      sizeHeading.appendChild(this.root);

      if (sectionWrapper) {
        sectionWrapper.classList.add('section-advanced-size-chart--mounted');
      }
    }

    bindDialog() {
      if (!this.dialog) {
        return;
      }

      const openButton = this.root.querySelector('[data-size-chart-open]');
      const closeButton = this.root.querySelector('[data-size-chart-close]');

      if (openButton) {
        openButton.addEventListener('click', () => {
          if (this.dialog.showModal) {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
        });
      }

      if (closeButton) {
        closeButton.addEventListener('click', () => this.dialog.close());
      }

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          this.dialog.close();
        }
      });
    }

    bindTabs() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.transition(() => this.activateTab(tab.dataset.sizeChartTab));
        });
      });
    }

    activateTab(id) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.sizeChartTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.sizeChartPanel !== id;
      });
    }

    bindUnits() {
      const storedUnit = window.localStorage.getItem('advanced-size-chart-unit');
      const defaultUnit = this.root.dataset.sizeChartUnit || 'cm';
      const unit = storedUnit || defaultUnit;

      this.setUnit(unit);

      this.unitButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.transition(() => this.setUnit(button.dataset.sizeChartUnitButton));
        });
      });
    }

    bindFitTools() {
      this.panels.forEach((panel) => {
        const tool = panel.querySelector('[data-size-fit-tool]');
        const range = tool ? tool.querySelector('[data-size-fit-range]') : null;
        const output = tool ? tool.querySelector('[data-size-fit-output]') : null;
        const rows = this.getFitRows(panel);

        if (!tool || !range || !output || !rows.length) {
          return;
        }

        const values = rows.map((row) => row.value);
        const min = Math.floor(Math.min.apply(null, values));
        const max = Math.ceil(Math.max.apply(null, values));
        const currentValue = Number(range.value);

        range.min = String(min);
        range.max = String(max);

        if (!Number.isFinite(currentValue) || currentValue < min || currentValue > max) {
          range.value = String(Math.round((min + max) / 2));
        }

        tool.hidden = false;
        range.addEventListener('input', () => this.updateFitTool(panel, tool));
        this.updateFitTool(panel, tool);
      });
    }

    getFitRows(panel) {
      let sourceRows = Array.from(panel.querySelectorAll('[data-unit-table="inch"] [data-size-row][data-fit-chest]'));

      if (!sourceRows.length) {
        sourceRows = Array.from(panel.querySelectorAll('[data-size-row][data-fit-chest]'));
      }

      return sourceRows.map((row) => {
        return {
          index: row.dataset.sizeRowIndex,
          size: row.dataset.sizeLabel || '',
          value: this.parseFitValue(row.dataset.fitChest)
        };
      }).filter((row) => Number.isFinite(row.value));
    }

    parseFitValue(value) {
      const matches = String(value || '').match(/\d+(?:\.\d+)?/g);

      if (!matches) {
        return Number.NaN;
      }

      const values = matches.map((number) => Number(number)).filter((number) => Number.isFinite(number));

      if (!values.length) {
        return Number.NaN;
      }

      return values.reduce((total, number) => total + number, 0) / values.length;
    }

    formatTemplate(template, values) {
      return Object.keys(values).reduce((text, key) => {
        return text.split('[' + key + ']').join(values[key]);
      }, template);
    }

    updateFitTool(panel, tool) {
      const range = tool.querySelector('[data-size-fit-range]');
      const output = tool.querySelector('[data-size-fit-output]');
      const result = tool.querySelector('[data-size-fit-result]');
      const rows = this.getFitRows(panel);

      if (!range || !output || !rows.length) {
        return;
      }

      const selectedChest = Number(range.value);
      const selectedText = String(Math.round(selectedChest * 10) / 10).replace(/\.0$/, '');
      const valueTemplate = tool.dataset.fitValueTemplate || '[value] inches';
      const resultTemplate = tool.dataset.fitResultTemplate || 'Nearest size: [size]';
      const chestTemplate = tool.dataset.fitChestTemplate || 'Chest [value] inches';
      let match = rows[0];

      rows.forEach((row) => {
        if (Math.abs(row.value - selectedChest) < Math.abs(match.value - selectedChest)) {
          match = row;
        }
      });

      output.textContent = this.formatTemplate(valueTemplate, { value: selectedText, size: match.size });

      if (result) {
        result.textContent = this.formatTemplate(resultTemplate, { value: selectedText, size: match.size }) + ' - ' + this.formatTemplate(chestTemplate, { value: selectedText, size: match.size });
        result.hidden = false;
      }

      panel.querySelectorAll('[data-size-row]').forEach((row) => {
        const active = row.dataset.sizeRowIndex === match.index;
        const heading = row.querySelector('th');

        row.classList.toggle('is-fit-match', active);

        if (!heading) {
          return;
        }

        if (active) {
          heading.setAttribute('data-fit-label', this.formatTemplate(chestTemplate, { value: selectedText, size: match.size }));
        } else {
          heading.removeAttribute('data-fit-label');
        }
      });
    }

    setUnit(unit) {
      this.root.dataset.sizeChartUnit = unit;
      window.localStorage.setItem('advanced-size-chart-unit', unit);

      this.unitButtons.forEach((button) => {
        const active = button.dataset.sizeChartUnitButton === unit;
        button.setAttribute('aria-pressed', String(active));
      });
    }
  }

  const initAdvancedSizeCharts = (container = document) => {
    container.querySelectorAll('[data-size-chart]').forEach((root) => {
      if (root.dataset.sizeChartReady) {
        return;
      }

      root.dataset.sizeChartReady = 'true';
      new AdvancedSizeChart(root);
    });
  };

  initAdvancedSizeCharts();

  document.addEventListener('shopify:section:load', (event) => {
    initAdvancedSizeCharts(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalogue-view-mobile"]) return;
  try {
    
(() => {
  const book = document.querySelector('[data-catalogue-book]');
  if (!book) return;
  document.body.classList.add('catalogue-mode');
  const whatsappSelector = '.squadkin-wrapper-container,.squadkin-whatsapp-button,#whatsapp-chat,ss-whatsapp-wrapper,#ss-whatsapp-button,#ss-whatsapp-dialog,[id*="whatsapp" i],[class*="whatsapp" i],a[href*="wa.me"],a[href*="api.whatsapp"],a[href*="whatsapp.com"],iframe[src*="whatsapp" i]';
  const hideWhatsappWidgets = root => {
    const elements = [];
    if (root.nodeType === 1 && root.matches(whatsappSelector)) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll(whatsappSelector));
    elements.forEach(element => {
      if (element.hidden && element.style.getPropertyValue('display') === 'none' && element.style.getPropertyPriority('display') === 'important') return;
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });
  };
  hideWhatsappWidgets(document);
  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') hideWhatsappWidgets(mutation.target);
      mutation.addedNodes.forEach(hideWhatsappWidgets);
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'hidden', 'style'], childList: true, subtree: true });
  const sheets = Array.from(book.querySelectorAll('[data-catalogue-sheet]'));
  const mobileView = window.matchMedia('(max-width: 749px)');
  let mobileIndex = new URLSearchParams(window.location.search).get('mobile_item') === 'last' ? Math.max(sheets.length - 1, 0) : 0;
  let turning = false;

  const sheetPreviewSource = sheet => sheet?.querySelector('[data-catalogue-gallery] img')?.currentSrc || sheet?.querySelector('[data-catalogue-gallery] img')?.src || '';
  const renderControlPreview = (preview, source) => {
    if (!preview || !source || preview.dataset.currentSource === source) return;
    const image = document.createElement('img');
    image.src = source;
    image.alt = '';
    image.decoding = 'async';
    preview.replaceChildren(image);
    preview.dataset.currentSource = source;
  };

  const updateLayout = () => {
    sheets.forEach((sheet, index) => {
      const visible = mobileView.matches ? index === mobileIndex : index < 2;
      sheet.hidden = !visible;
      sheet.classList.toggle('is-left', visible && (mobileView.matches || index === 0));
      sheet.classList.toggle('is-right', visible && !mobileView.matches && index === 1);
    });
    const offset = Number(book.dataset.productOffset || 0);
    const total = Number(book.dataset.productTotal || sheets.length);
    const progress = book.querySelector('[data-catalogue-progress]');
    if (progress) {
      progress.textContent = mobileView.matches
        ? `${offset + mobileIndex + 1} / ${total}`
        : `${offset + 1}–${Math.min(offset + sheets.length, total)} / ${total}`;
    }
    const previousButton = book.querySelector('[data-catalogue-previous]');
    const nextButton = book.querySelector('[data-catalogue-next]');
    previousButton.hidden = mobileView.matches ? mobileIndex === 0 && !book.dataset.previousPage : !book.dataset.previousPage;
    nextButton.hidden = mobileView.matches ? mobileIndex === sheets.length - 1 && !book.dataset.nextPage : !book.dataset.nextPage;
    const previousPreview = book.querySelector('[data-previous-preview]');
    const nextPreview = book.querySelector('[data-next-preview]');
    const previousSource = mobileView.matches && mobileIndex > 0
      ? sheetPreviewSource(sheets[mobileIndex - 1])
      : previousPreview.dataset.remoteSource;
    const nextSource = mobileView.matches && mobileIndex < sheets.length - 1
      ? sheetPreviewSource(sheets[mobileIndex + 1])
      : nextPreview.dataset.remoteSource;
    renderControlPreview(previousPreview, previousSource);
    renderControlPreview(nextPreview, nextSource);
  };

  const playPageSound = () => {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;
    const context = new AudioContextClass();
    const duration = 0.22;
    const buffer = context.createBuffer(1, context.sampleRate * duration, context.sampleRate);
    const data = buffer.getChannelData(0);
    for (let index = 0; index < data.length; index += 1) {
      const envelope = Math.sin(Math.PI * index / data.length) * (1 - index / data.length);
      data[index] = (Math.random() * 2 - 1) * envelope;
    }
    const source = context.createBufferSource();
    const filter = context.createBiquadFilter();
    const gain = context.createGain();
    filter.type = 'bandpass';
    filter.frequency.value = 1250;
    filter.Q.value = 0.7;
    gain.gain.value = 0.12;
    source.buffer = buffer;
    source.connect(filter).connect(gain).connect(context.destination);
    source.start();
    source.onended = () => context.close();
  };

  const turn = direction => {
    if (turning || sheets.length === 0) return;
    if (mobileView.matches) {
      const localIndex = mobileIndex + direction;
      if (localIndex >= 0 && localIndex < sheets.length) {
        turning = true;
        playPageSound();
        const outgoing = sheets[mobileIndex];
        outgoing.classList.add(direction > 0 ? 'is-turning-next' : 'is-turning-previous');
        setTimeout(() => {
          outgoing.classList.remove('is-turning-next', 'is-turning-previous');
          mobileIndex = localIndex;
          turning = false;
          updateLayout();
        }, 280);
        return;
      }
    }
    const destination = direction > 0 ? book.dataset.nextPage : book.dataset.previousPage;
    if (!destination) return;
    turning = true;
    playPageSound();
    const outgoing = direction > 0 ? sheets[sheets.length - 1] : sheets[0];
    outgoing.classList.add(direction > 0 ? 'is-turning-next' : 'is-turning-previous');
    setTimeout(() => {
      window.location.href = destination;
    }, 280);
  };

  const refreshDots = sheet => {
    const gallery = sheet.querySelector('[data-catalogue-gallery]');
    const dots = sheet.querySelector('[data-catalogue-dots]');
    const visibleMedia = Array.from(sheet.querySelectorAll('[data-catalogue-media]')).filter(media => !media.hidden);
    if (!gallery || !dots) return;
    dots.replaceChildren(...visibleMedia.map((media, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `catalogue-media-dot${index === 0 ? ' is-active' : ''}`;
      dot.dataset.catalogueDot = String(index);
      dot.setAttribute('aria-label', `${index + 1} / ${visibleMedia.length}`);
      return dot;
    }));
    dots.hidden = visibleMedia.length < 2;
    gallery.onscroll = () => {
      const activeIndex = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      dots.querySelectorAll('[data-catalogue-dot]').forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };
  };

  const showVariantGroup = (sheet, variant) => {
    const gallery = sheet.querySelector('[data-catalogue-gallery]');
    const selectedGroup = variant.dataset.variantGroup;
    let visibleMedia = 0;
    sheet.querySelectorAll('[data-catalogue-variant]').forEach(button => button.classList.toggle('is-active', button === variant));
    sheet.querySelectorAll('[data-catalogue-media]').forEach(media => {
      const visible = media.dataset.variantGroup === selectedGroup;
      media.hidden = !visible;
      if (visible) visibleMedia += 1;
      media.querySelectorAll('video').forEach(video => video.pause());
    });
    if (visibleMedia === 0) sheet.querySelector('[data-catalogue-media]').hidden = false;
    sheet.querySelectorAll('[data-catalogue-media] img, [data-catalogue-media] video').forEach(media => { media.style.transform = ''; });
    gallery.scrollLeft = 0;
    gallery.dispatchEvent(new CustomEvent('catalogue:reset-zoom'));
    refreshDots(sheet);
  };

  const buildVariantMediaGroups = sheet => {
    const mediaItems = Array.from(sheet.querySelectorAll('[data-catalogue-media][data-media-id]'));
    const variants = Array.from(sheet.querySelectorAll('[data-catalogue-variant]'));
    if (mediaItems.length === 0 || variants.length === 0) return;
    const markers = variants.map(variant => ({
      variant,
      index: mediaItems.findIndex(media => media.dataset.mediaId === variant.dataset.featuredMediaId)
    })).filter(marker => marker.index >= 0).sort((first, second) => first.index - second.index);
    if (markers.length === 0) {
      mediaItems.forEach(media => { media.dataset.variantGroup = variants[0].dataset.variantGroup; });
      showVariantGroup(sheet, variants[0]);
      return;
    }
    mediaItems.slice(0, markers[0].index).forEach(media => { media.dataset.variantGroup = markers[0].variant.dataset.variantGroup; });
    markers.forEach((marker, index) => {
      const nextIndex = markers[index + 1]?.index ?? mediaItems.length;
      mediaItems.slice(marker.index, nextIndex).forEach(media => { media.dataset.variantGroup = marker.variant.dataset.variantGroup; });
    });
    showVariantGroup(sheet, markers[0].variant);
  };

  sheets.forEach(sheet => {
    buildVariantMediaGroups(sheet);
    refreshDots(sheet);
  });

  const preloadProductPreview = async (destination, preview, prerender = false) => {
    if (!destination || !preview) return;
    if (prerender && !mobileView.matches && HTMLScriptElement.supports?.('speculationrules')) {
      const rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.textContent = JSON.stringify({ prerender: [{ source: 'list', urls: [destination] }] });
      document.head.append(rules);
    }
    const response = await fetch(destination, { credentials: 'same-origin' });
    if (!response.ok) return;
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const productImage = parsed.querySelector('[data-catalogue-gallery] img');
    const source = productImage?.getAttribute('src');
    if (!source) return;
    preview.dataset.remoteSource = source;
    updateLayout();
  };

  book.querySelector('[data-catalogue-previous]').hidden = !book.dataset.previousPage;
  book.querySelector('[data-catalogue-next]').hidden = !book.dataset.nextPage;
  const warmCatalogueNavigation = () => {
    preloadProductPreview(book.dataset.nextPage, book.querySelector('[data-next-preview]'), true).catch(() => {});
    preloadProductPreview(book.dataset.previousPage, book.querySelector('[data-previous-preview]')).catch(() => {});
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(warmCatalogueNavigation, { timeout: 1800 });
  } else {
    window.setTimeout(warmCatalogueNavigation, 900);
  }

  const installZoom = sheet => {
    const gallery = sheet.querySelector('[data-catalogue-gallery]');
    if (!gallery) return;
    let startDistance = 0;
    let startScale = 1;
    let scale = 1;
    let lastTap = 0;
    let pinching = false;
    let panning = false;
    let moved = false;
    let panX = 0;
    let panY = 0;
    let panStartX = 0;
    let panStartY = 0;
    const activeVisual = () => {
      const visibleMedia = Array.from(gallery.querySelectorAll('[data-catalogue-media]')).filter(media => !media.hidden);
      const activeIndex = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      return visibleMedia[activeIndex]?.querySelector('img, video');
    };
    const touchDistance = touches => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
    const applyZoom = () => {
      const visual = activeVisual();
      if (visual) visual.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${scale})`;
    };
    const clampPan = () => {
      const maxX = gallery.clientWidth * (scale - 1) / 2;
      const maxY = gallery.clientHeight * (scale - 1) / 2;
      panX = Math.max(-maxX, Math.min(maxX, panX));
      panY = Math.max(-maxY, Math.min(maxY, panY));
    };
    gallery.addEventListener('catalogue:reset-zoom', () => {
      scale = 1;
      panX = 0;
      panY = 0;
    });
    gallery.addEventListener('touchstart', event => {
      if (event.touches.length === 2) {
        pinching = true;
        panning = false;
        startDistance = touchDistance(event.touches);
        startScale = scale;
      } else if (event.touches.length === 1 && scale > 1) {
        panning = true;
        moved = false;
        panStartX = event.touches[0].clientX - panX;
        panStartY = event.touches[0].clientY - panY;
      }
    }, { passive: true });
    gallery.addEventListener('touchmove', event => {
      if (event.touches.length === 2 && startDistance > 0) {
        event.preventDefault();
        scale = Math.min(3.5, Math.max(1, startScale * touchDistance(event.touches) / startDistance));
        if (scale === 1) {
          panX = 0;
          panY = 0;
        }
        clampPan();
        applyZoom();
      } else if (event.touches.length === 1 && panning && scale > 1) {
        event.preventDefault();
        panX = event.touches[0].clientX - panStartX;
        panY = event.touches[0].clientY - panStartY;
        moved = true;
        clampPan();
        applyZoom();
      }
    }, { passive: false });
    gallery.addEventListener('touchend', event => {
      if (event.touches.length < 2) startDistance = 0;
      if (pinching && event.touches.length < 2) {
        pinching = false;
        return;
      }
      if (panning && event.touches.length === 0) panning = false;
      if (event.changedTouches.length === 1 && !moved) {
        const now = Date.now();
        if (now - lastTap < 280) {
          if (scale > 1) {
            scale = 1;
            panX = 0;
            panY = 0;
          } else {
            scale = 2.25;
            const rect = gallery.getBoundingClientRect();
            panX = (rect.left + rect.width / 2 - event.changedTouches[0].clientX) * 0.72;
            panY = (rect.top + rect.height / 2 - event.changedTouches[0].clientY) * 0.72;
            clampPan();
          }
          applyZoom();
        }
        lastTap = now;
      }
      if (event.touches.length === 0) moved = false;
    }, { passive: true });
  };

  sheets.forEach(installZoom);
  mobileView.addEventListener('change', () => {
    mobileIndex = Math.min(mobileIndex, sheets.length - 1);
    updateLayout();
  });
  updateLayout();

  book.addEventListener('click', event => {
    if (event.target.closest('[data-catalogue-next]')) turn(1);
    if (event.target.closest('[data-catalogue-previous]')) turn(-1);
    const dot = event.target.closest('[data-catalogue-dot]');
    if (dot) {
      const gallery = dot.closest('[data-catalogue-sheet]').querySelector('[data-catalogue-gallery]');
      gallery.scrollTo({ left: Number(dot.dataset.catalogueDot) * gallery.clientWidth, behavior: 'smooth' });
    }
    const variant = event.target.closest('[data-catalogue-variant]');
    if (variant) {
      const sheet = variant.closest('[data-catalogue-sheet]');
      showVariantGroup(sheet, variant);
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') window.location.href = book.querySelector('.catalogue-book__close').href;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalogue-view"]) return;
  try {
    
(() => {
  if (window.matchMedia('(max-width: 1024px)').matches) {
    const mobileUrl = new URL(window.location.href);
    mobileUrl.searchParams.set('view', 'catalogue-mobile');
    mobileUrl.searchParams.delete('page');
    mobileUrl.searchParams.delete('mobile_item');
    window.location.replace(mobileUrl.toString());
    return;
  }
  const book = document.querySelector('[data-catalogue-book]');
  if (!book) return;
  document.body.classList.add('catalogue-mode');
  const whatsappSelector = '.squadkin-wrapper-container,.squadkin-whatsapp-button,#whatsapp-chat,ss-whatsapp-wrapper,#ss-whatsapp-button,#ss-whatsapp-dialog,[id*="whatsapp" i],[class*="whatsapp" i],a[href*="wa.me"],a[href*="api.whatsapp"],a[href*="whatsapp.com"],iframe[src*="whatsapp" i]';
  const hideWhatsappWidgets = root => {
    const elements = [];
    if (root.nodeType === 1 && root.matches(whatsappSelector)) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll(whatsappSelector));
    elements.forEach(element => {
      if (element.hidden && element.style.getPropertyValue('display') === 'none' && element.style.getPropertyPriority('display') === 'important') return;
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });
  };
  hideWhatsappWidgets(document);
  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') hideWhatsappWidgets(mutation.target);
      mutation.addedNodes.forEach(hideWhatsappWidgets);
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'hidden', 'style'], childList: true, subtree: true });
  const sheets = Array.from(book.querySelectorAll('[data-catalogue-sheet]'));
  const mobileView = window.matchMedia('(max-width: 1024px)');
  let mobileIndex = new URLSearchParams(window.location.search).get('mobile_item') === 'last' ? Math.max(sheets.length - 1, 0) : 0;
  let turning = false;

  const sheetPreviewSource = sheet => sheet?.querySelector('[data-catalogue-gallery] img')?.currentSrc || sheet?.querySelector('[data-catalogue-gallery] img')?.src || '';
  const renderControlPreview = (preview, source) => {
    if (!preview || !source || preview.dataset.currentSource === source) return;
    const image = document.createElement('img');
    image.src = source;
    image.alt = '';
    image.decoding = 'async';
    preview.replaceChildren(image);
    preview.dataset.currentSource = source;
  };

  const updateLayout = () => {
    sheets.forEach((sheet, index) => {
      const visible = mobileView.matches ? index === mobileIndex : index < 2;
      sheet.hidden = !visible;
      sheet.classList.toggle('is-left', visible && (mobileView.matches || index === 0));
      sheet.classList.toggle('is-right', visible && !mobileView.matches && index === 1);
    });
    const offset = Number(book.dataset.productOffset || 0);
    const total = Number(book.dataset.productTotal || sheets.length);
    const progress = book.querySelector('[data-catalogue-progress]');
    if (progress) {
      progress.textContent = mobileView.matches
        ? `${offset + mobileIndex + 1} / ${total}`
        : `${offset + 1}–${Math.min(offset + sheets.length, total)} / ${total}`;
    }
    const previousButton = book.querySelector('[data-catalogue-previous]');
    const nextButton = book.querySelector('[data-catalogue-next]');
    previousButton.hidden = mobileView.matches ? mobileIndex === 0 && !book.dataset.previousPage : !book.dataset.previousPage;
    nextButton.hidden = mobileView.matches ? mobileIndex === sheets.length - 1 && !book.dataset.nextPage : !book.dataset.nextPage;
    const previousPreview = book.querySelector('[data-previous-preview]');
    const nextPreview = book.querySelector('[data-next-preview]');
    const previousSource = mobileView.matches && mobileIndex > 0
      ? sheetPreviewSource(sheets[mobileIndex - 1])
      : previousPreview.dataset.remoteSource;
    const nextSource = mobileView.matches && mobileIndex < sheets.length - 1
      ? sheetPreviewSource(sheets[mobileIndex + 1])
      : nextPreview.dataset.remoteSource;
    renderControlPreview(previousPreview, previousSource);
    renderControlPreview(nextPreview, nextSource);
  };

  const playPageSound = () => {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;
    const context = new AudioContextClass();
    const duration = 0.22;
    const buffer = context.createBuffer(1, context.sampleRate * duration, context.sampleRate);
    const data = buffer.getChannelData(0);
    for (let index = 0; index < data.length; index += 1) {
      const envelope = Math.sin(Math.PI * index / data.length) * (1 - index / data.length);
      data[index] = (Math.random() * 2 - 1) * envelope;
    }
    const source = context.createBufferSource();
    const filter = context.createBiquadFilter();
    const gain = context.createGain();
    filter.type = 'bandpass';
    filter.frequency.value = 1250;
    filter.Q.value = 0.7;
    gain.gain.value = 0.12;
    source.buffer = buffer;
    source.connect(filter).connect(gain).connect(context.destination);
    source.start();
    source.onended = () => context.close();
  };

  const turn = direction => {
    if (turning || sheets.length === 0) return;
    if (mobileView.matches) {
      const localIndex = mobileIndex + direction;
      if (localIndex >= 0 && localIndex < sheets.length) {
        turning = true;
        playPageSound();
        const outgoing = sheets[mobileIndex];
        outgoing.classList.add(direction > 0 ? 'is-turning-next' : 'is-turning-previous');
        setTimeout(() => {
          outgoing.classList.remove('is-turning-next', 'is-turning-previous');
          mobileIndex = localIndex;
          turning = false;
          updateLayout();
        }, 280);
        return;
      }
    }
    const destination = direction > 0 ? book.dataset.nextPage : book.dataset.previousPage;
    if (!destination) return;
    turning = true;
    playPageSound();
    const outgoing = direction > 0 ? sheets[sheets.length - 1] : sheets[0];
    outgoing.classList.add(direction > 0 ? 'is-turning-next' : 'is-turning-previous');
    setTimeout(() => {
      window.location.href = destination;
    }, 280);
  };

  const refreshDots = sheet => {
    const gallery = sheet.querySelector('[data-catalogue-gallery]');
    const dots = sheet.querySelector('[data-catalogue-dots]');
    const visibleMedia = Array.from(sheet.querySelectorAll('[data-catalogue-media]')).filter(media => !media.hidden);
    if (!gallery || !dots) return;
    dots.replaceChildren(...visibleMedia.map((media, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `catalogue-media-dot${index === 0 ? ' is-active' : ''}`;
      dot.dataset.catalogueDot = String(index);
      dot.setAttribute('aria-label', `${index + 1} / ${visibleMedia.length}`);
      return dot;
    }));
    dots.hidden = visibleMedia.length < 2;
    gallery.onscroll = () => {
      const activeIndex = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      dots.querySelectorAll('[data-catalogue-dot]').forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };
  };

  const showVariantGroup = (sheet, variant) => {
    const gallery = sheet.querySelector('[data-catalogue-gallery]');
    const selectedGroup = variant.dataset.variantGroup;
    let visibleMedia = 0;
    sheet.querySelectorAll('[data-catalogue-variant]').forEach(button => button.classList.toggle('is-active', button === variant));
    sheet.querySelectorAll('[data-catalogue-media]').forEach(media => {
      const visible = media.dataset.variantGroup === selectedGroup;
      media.hidden = !visible;
      if (visible) visibleMedia += 1;
      media.querySelectorAll('video').forEach(video => video.pause());
    });
    if (visibleMedia === 0) sheet.querySelector('[data-catalogue-media]').hidden = false;
    sheet.querySelectorAll('[data-catalogue-media] img, [data-catalogue-media] video').forEach(media => { media.style.transform = ''; });
    gallery.scrollLeft = 0;
    gallery.dispatchEvent(new CustomEvent('catalogue:reset-zoom'));
    refreshDots(sheet);
  };

  const buildVariantMediaGroups = sheet => {
    const mediaItems = Array.from(sheet.querySelectorAll('[data-catalogue-media][data-media-id]'));
    const variants = Array.from(sheet.querySelectorAll('[data-catalogue-variant]'));
    if (mediaItems.length === 0 || variants.length === 0) return;
    const markers = variants.map(variant => ({
      variant,
      index: mediaItems.findIndex(media => media.dataset.mediaId === variant.dataset.featuredMediaId)
    })).filter(marker => marker.index >= 0).sort((first, second) => first.index - second.index);
    if (markers.length === 0) {
      mediaItems.forEach(media => { media.dataset.variantGroup = variants[0].dataset.variantGroup; });
      showVariantGroup(sheet, variants[0]);
      return;
    }
    mediaItems.slice(0, markers[0].index).forEach(media => { media.dataset.variantGroup = markers[0].variant.dataset.variantGroup; });
    markers.forEach((marker, index) => {
      const nextIndex = markers[index + 1]?.index ?? mediaItems.length;
      mediaItems.slice(marker.index, nextIndex).forEach(media => { media.dataset.variantGroup = marker.variant.dataset.variantGroup; });
    });
    showVariantGroup(sheet, markers[0].variant);
  };

  sheets.forEach(sheet => {
    buildVariantMediaGroups(sheet);
    refreshDots(sheet);
  });

  const preloadProductPreview = async (destination, preview, prerender = false) => {
    if (!destination || !preview) return;
    if (prerender && !mobileView.matches && HTMLScriptElement.supports?.('speculationrules')) {
      const rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.textContent = JSON.stringify({ prerender: [{ source: 'list', urls: [destination] }] });
      document.head.append(rules);
    }
    const response = await fetch(destination, { credentials: 'same-origin' });
    if (!response.ok) return;
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const productImage = parsed.querySelector('[data-catalogue-gallery] img');
    const source = productImage?.getAttribute('src');
    if (!source) return;
    preview.dataset.remoteSource = source;
    updateLayout();
  };

  book.querySelector('[data-catalogue-previous]').hidden = !book.dataset.previousPage;
  book.querySelector('[data-catalogue-next]').hidden = !book.dataset.nextPage;
  const warmCatalogueNavigation = () => {
    preloadProductPreview(book.dataset.nextPage, book.querySelector('[data-next-preview]'), true).catch(() => {});
    preloadProductPreview(book.dataset.previousPage, book.querySelector('[data-previous-preview]')).catch(() => {});
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(warmCatalogueNavigation, { timeout: 1800 });
  } else {
    window.setTimeout(warmCatalogueNavigation, 900);
  }

  const installZoom = sheet => {
    const gallery = sheet.querySelector('[data-catalogue-gallery]');
    if (!gallery) return;
    let startDistance = 0;
    let startScale = 1;
    let scale = 1;
    let lastTap = 0;
    let pinching = false;
    let panning = false;
    let moved = false;
    let panX = 0;
    let panY = 0;
    let panStartX = 0;
    let panStartY = 0;
    const activeVisual = () => {
      const visibleMedia = Array.from(gallery.querySelectorAll('[data-catalogue-media]')).filter(media => !media.hidden);
      const activeIndex = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      return visibleMedia[activeIndex]?.querySelector('img, video');
    };
    const touchDistance = touches => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
    const applyZoom = () => {
      const visual = activeVisual();
      if (visual) visual.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${scale})`;
    };
    const clampPan = () => {
      const maxX = gallery.clientWidth * (scale - 1) / 2;
      const maxY = gallery.clientHeight * (scale - 1) / 2;
      panX = Math.max(-maxX, Math.min(maxX, panX));
      panY = Math.max(-maxY, Math.min(maxY, panY));
    };
    gallery.addEventListener('catalogue:reset-zoom', () => {
      scale = 1;
      panX = 0;
      panY = 0;
    });
    gallery.addEventListener('touchstart', event => {
      if (event.touches.length === 2) {
        pinching = true;
        panning = false;
        startDistance = touchDistance(event.touches);
        startScale = scale;
      } else if (event.touches.length === 1 && scale > 1) {
        panning = true;
        moved = false;
        panStartX = event.touches[0].clientX - panX;
        panStartY = event.touches[0].clientY - panY;
      }
    }, { passive: true });
    gallery.addEventListener('touchmove', event => {
      if (event.touches.length === 2 && startDistance > 0) {
        event.preventDefault();
        scale = Math.min(3.5, Math.max(1, startScale * touchDistance(event.touches) / startDistance));
        if (scale === 1) {
          panX = 0;
          panY = 0;
        }
        clampPan();
        applyZoom();
      } else if (event.touches.length === 1 && panning && scale > 1) {
        event.preventDefault();
        panX = event.touches[0].clientX - panStartX;
        panY = event.touches[0].clientY - panStartY;
        moved = true;
        clampPan();
        applyZoom();
      }
    }, { passive: false });
    gallery.addEventListener('touchend', event => {
      if (event.touches.length < 2) startDistance = 0;
      if (pinching && event.touches.length < 2) {
        pinching = false;
        return;
      }
      if (panning && event.touches.length === 0) panning = false;
      if (event.changedTouches.length === 1 && !moved) {
        const now = Date.now();
        if (now - lastTap < 280) {
          if (scale > 1) {
            scale = 1;
            panX = 0;
            panY = 0;
          } else {
            scale = 2.25;
            const rect = gallery.getBoundingClientRect();
            panX = (rect.left + rect.width / 2 - event.changedTouches[0].clientX) * 0.72;
            panY = (rect.top + rect.height / 2 - event.changedTouches[0].clientY) * 0.72;
            clampPan();
          }
          applyZoom();
        }
        lastTap = now;
      }
      if (event.touches.length === 0) moved = false;
    }, { passive: true });
  };

  sheets.forEach(installZoom);
  mobileView.addEventListener('change', () => {
    mobileIndex = Math.min(mobileIndex, sheets.length - 1);
    updateLayout();
  });
  updateLayout();

  book.addEventListener('click', event => {
    if (event.target.closest('[data-catalogue-next]')) turn(1);
    if (event.target.closest('[data-catalogue-previous]')) turn(-1);
    const dot = event.target.closest('[data-catalogue-dot]');
    if (dot) {
      const gallery = dot.closest('[data-catalogue-sheet]').querySelector('[data-catalogue-gallery]');
      gallery.scrollTo({ left: Number(dot.dataset.catalogueDot) * gallery.clientWidth, behavior: 'smooth' });
    }
    const variant = event.target.closest('[data-catalogue-variant]');
    if (variant) {
      const sheet = variant.closest('[data-catalogue-sheet]');
      showVariantGroup(sheet, variant);
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') window.location.href = book.querySelector('.catalogue-book__close').href;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
